// extracted by mini-css-extract-plugin
export default {"root":"root--a2rht","icon":"icon--EA3UG","title":"title--hvOgi"};